import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { addDoor, emptyPreviewImages } from "actions";
import { StepHistory } from "components/Steps";
import Cart from "../components/Cart";
import Logo from "../components/Logo";

import {
    Room,
    Type,
    upvcModel,
    upvcColour,
    upvcHandle,
    upvcHardware,
    upvcSize,
    compoStyle,
    compoColour,
    compoFrame,
    compoHandle,
    compoHardware,
    compoGlass
} from "./DoorForm";

import "css/DoorPage.css";
import { emptyPreviousPreviews } from "./../actions";
import ReactCSSTransitionReplace from "react-css-transition-replace";

class DoorPage extends Component {
    constructor(props) {
        super(props);
        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.setDoorType = this.setDoorType.bind(this);
        this.setStyleSettings = this.setStyleSettings.bind(this);
        this.changePage = this.changePage.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            page: 0,
            isComposite: false,
            isFrenchDoor: false,
            isPatioOrBifold: true,
            isBifold: true,
            showDoorKnockerChoice: true,
            showDoorLetterboxChoice: true,
            showGlassStep: true
        };
    }

    componentDidMount() {
        this.props.emptyPreviousPreviews();
    }

    getFormList() {
        if (this.state.isComposite) {
            let compStepList = [
                Room,
                Type,
                compoStyle,
                compoColour,
                compoFrame,
                compoHandle
            ];

            if (this.state.showDoorKnockerChoice || this.state.showDoorLetterboxChoice)
                compStepList.push(compoHardware);
            if (this.state.showGlassStep)
                compStepList.push(compoGlass);

            return compStepList;
        }

        let upvcStepList = [Room, Type];

        if(this.state.isPatioOrBifold)
            upvcStepList.push(upvcSize);

        upvcStepList.push(upvcModel, upvcColour, upvcHandle);

        if (!this.state.isFrenchDoor && this.state.showDoorLetterboxChoice) {
            upvcStepList.push(upvcHardware);
        }
        
        return upvcStepList;
    }

    setDoorType(typeName) {
        let newState = {
            isComposite: false,
            isFrenchDoor: false,
            isPatioOrBifold: false,
            isBifold: false
        };

        if (/composite/i.test(typeName))
            newState.isComposite = true;

        if (/french/i.test(typeName))
            newState.isFrenchDoor = true;

        if(/patio/i.test(typeName))
            newState.isPatioOrBifold = true;

        if (/bi-?fold/i.test(typeName)) {
            newState.isPatioOrBifold = true;
            newState.isBifold = true;
        }

        this.setState(newState);

        this.props.emptyPreviousPreviews();
    }

    setStyleSettings(style) {
        let state = {
            showDoorKnockerChoice: style.canHaveKnocker === true,
            showDoorLetterboxChoice: style.canHaveLetterbox === true,
            showGlassStep: style.isSolidDoor === false
        };

        this.setState(state);
    }

    nextPage() {
        this.changePage(this.state.page + 1);
    }
    previousPage() {
        this.changePage(this.state.page - 1);
    }
    changePage(newPage) {
        this.props.emptyPreviewImages();
        this.setState({ page: newPage });
    }

    handleSubmit(values) {

        const doorType = {
            isComposite: this.state.isComposite,
            isPatioOrBifold: this.state.isPatioOrBifold,
        }

        this.props.addDoor(values, doorType);

        this.props.history.push("/Summary");
    }

    render() {
        const { page } = this.state;

        let properties = {
            onSubmit: this.nextPage,
            previousPage: this.previousPage,
            setDoorType: this.setDoorType,
            setStyleSettings: this.setStyleSettings,
            showDoorKnockerChoice: this.state.showDoorKnockerChoice,
            showDoorLetterboxChoice: this.state.showDoorLetterboxChoice,
            isFrenchDoor: this.state.isFrenchDoor,
            isPatioOrBifold: this.state.isPatioOrBifold,
            isBifold: this.state.isBifold
        };

        if (page === 0) {
            delete properties.previousPage;
        }

        if (page === this.getFormList().length - 1) {
            properties.onSubmit = this.handleSubmit;
        }

        let Step = this.getFormList()[page];

        window.dataLayer.push({
            event: "VirtualPageView",
            "VirtualPageURL": this.props.location.pathname + "/" + Step.name
        });

        return (
            <div className="DoorPage">
                <Logo topLeft={true} hideTextOnSmall={true} />
                <Cart />
                <StepHistory StepList={this.getFormList()} StepIndex={this.state.page} onStepClick={this.changePage} />

                <ReactCSSTransitionReplace
                    transitionName={"page"}
                    transitionEnterTimeout={2000}
                    transitionLeaveTimeout={1000}
                    className="transition-container">
                    <Step.form key={Step.name} {...properties} />
                </ReactCSSTransitionReplace>
            </div>
        );
    }
}

export default withRouter(connect(null, { addDoor, emptyPreviewImages, emptyPreviousPreviews })(DoorPage));



// WEBPACK FOOTER //
// ./src/containers/DoorPage.js